(() => {
  const data = window.ROOF_COMMUNITY;
  const root = document.querySelector('[data-community]');
  const uiNode = document.querySelector('[data-community-ui]');
  if (!data || !root || !uiNode) return;
  const ui = {...JSON.parse(uiNode.textContent), ...JSON.parse(document.querySelector('[data-annotation-ui]').textContent)};
  const family = root.dataset.community;
  const section = data[family];
  if (!section) { root.hidden = true; return; }
  const make = (tag, className, text) => {
    const el = document.createElement(tag);
    if (className) el.className = className;
    if (text) el.textContent = text;
    return el;
  };
  const externalLink = (url, text, className) => {
    const a = make('a', className, text);
    a.href = url;
    a.target = '_blank';
    a.rel = 'noopener';
    return a;
  };
  const videos = section.videos || [];
  root.classList.toggle('no-videos', videos.length === 0);
  const grid = root.querySelector('[data-community-videos]');
  const invitation = root.querySelector('[data-video-invitation]');
  if (invitation && videos.length > 0 && videos.length <= 2) {
    grid.parentElement.classList.add('has-video-invitation');
    grid.style.setProperty('--video-count', videos.length);
    invitation.hidden = false;
  }
  for (const item of videos) {
    const assetScript = document.querySelector('script[src*="mt-roof-community-data.js"]');
    const poster = item.posterAsset ? new URL(item.posterAsset, assetScript.src).href : item.poster;
    const article = make('article', 'roof-video-card');
    article.dataset.videoId = item.id;
    const stage = make('div', 'roof-video-stage');
    const cover = make('button', 'roof-video-cover');
    cover.type = 'button';
    cover.setAttribute('aria-label', ui.play + ': ' + item.title + ' — ' + item.creator);
    const image = make('img');
    image.src = poster;
    image.alt = item.alt || item.title;
    image.loading = 'lazy';
    image.width = 600;
    image.height = 800;
    cover.append(image);
    const play = make('span', 'roof-video-play', '▶');
    play.setAttribute('aria-hidden', 'true');
    cover.append(play);
    stage.append(cover);
    cover.addEventListener('click', () => {
      const video = make('video');
      video.controls = true;
      video.playsInline = true;
      video.preload = 'none';
      video.crossOrigin = 'anonymous';
      video.poster = poster;
      video.setAttribute('aria-label', item.title + ' — ' + item.creator);
      if (item.captionsAsset) {
        const track = make('track');
        track.kind = 'captions';
        track.srclang = item.language || 'en';
        track.label = ui.captions_english;
        const script = document.querySelector('script[src*="mt-roof-community-data.js"]');
        track.src = new URL(item.captionsAsset, script.src).href;
        video.append(track);
      }
      video.addEventListener('play', () => {
        document.querySelectorAll('.roof-community video').forEach(other => { if (other !== video) other.pause(); });
      });
      video.addEventListener('error', () => {
        if (!stage.querySelector('.roof-video-error')) stage.append(externalLink(item.source, ui.watch_original + ' ↗', 'roof-video-error'));
      });
      stage.replaceChildren(video);
      video.src = item.video;
      video.focus();
      const playing = video.play();
      if (playing) playing.catch(() => {});
    });
    article.append(stage, make('h3', '', item.title), make('p', 'roof-video-caption', item.description));
    const credit = make('div', 'roof-video-credit');
    credit.append(make('span', '', item.creator), externalLink(item.source, ui.watch_original + ' ↗'));
    article.append(credit, make('p', 'roof-video-kind', item.kind === 'Brand demonstration' ? ui.brand_demo : item.gifted ? ui.gifted : ui.collaboration));
    grid.append(article);
  }
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function bindCarousel(track, toolbar) {
    const previous = toolbar.querySelector('[data-carousel-prev]');
    const next = toolbar.querySelector('[data-carousel-next]');
    const status = toolbar.querySelector('[data-carousel-status]');
    const cards = [...track.children];
    function updateCarousel() {
      const max = track.scrollWidth - track.clientWidth;
      previous.disabled = track.scrollLeft < 4;
      next.disabled = track.scrollLeft >= max - 4;
      toolbar.hidden = max < 4;
      const bounds = track.getBoundingClientRect();
      const visible = cards.map((card, i) => ({i, rect: card.getBoundingClientRect()}))
        .filter(({rect}) => rect.left < bounds.right - rect.width / 2 && rect.right > bounds.left + rect.width / 2);
      if (visible.length) status.textContent = ui.visible + ' ' + (visible[0].i + 1) + '–' + (visible.at(-1).i + 1) + ' / ' + cards.length;
      track.querySelectorAll('video').forEach(video => {
        const rect = video.getBoundingClientRect();
        if (rect.right <= bounds.left || rect.left >= bounds.right) video.pause();
      });
    }
    function moveCarousel(direction) {
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const width = cards[0]?.getBoundingClientRect().width;
      if (!width) return;
      const step = width + gap;
      const count = Math.max(1, Math.floor((track.clientWidth + gap + 1) / step));
      track.scrollBy({left: direction * step * count, behavior: reducedMotion.matches ? 'auto' : 'smooth'});
    }
    previous.addEventListener('click', () => moveCarousel(-1));
    next.addEventListener('click', () => moveCarousel(1));
    track.addEventListener('keydown', event => {
      if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      moveCarousel(event.key === 'ArrowRight' ? 1 : -1);
    });
    track.addEventListener('scroll', updateCarousel, {passive:true});
    new ResizeObserver(updateCarousel).observe(track);
    updateCarousel();
  }
  bindCarousel(grid, root.querySelector('[data-video-toolbar]'));

  const reviews = root.querySelector('.roof-reviews');
  if (!reviews) return;
  const reviewGrid = reviews.querySelector('[data-community-reviews]');
  if (section.reviewSource) {
    reviews.querySelector('[data-all-reviews]').append(externalLink(section.reviewSource, ui.reviews_link + ' ↗', 'text-link'));
  }
  const featured = (section.reviews || []).filter(item =>
    [4, 5].includes(item.stars) && item.text && item.author &&
    /^https:\/\/www\.amazon\.com\/portal\/customer-reviews\/srp\/-\/R[A-Z0-9]+\/?$/.test(item.source));
  for (const item of featured) {
    const card = make('article', 'roof-review-card');
    const stars = make('span', 'roof-review-stars');
    stars.setAttribute('role', 'img');
    stars.setAttribute('aria-label', reviews.dataset.starsLabel.replace('[rating]', item.stars));
    const icons = make('span', '', '★'.repeat(item.stars) + '☆'.repeat(5 - item.stars));
    icons.setAttribute('aria-hidden', 'true');
    stars.append(icons);
    const credit = make('p', 'roof-review-credit', item.author + ' · ' + item.detail);
    if (item.vine) credit.append(make('span', 'roof-review-disclosure', reviews.dataset.vineLabel));
    const source = externalLink(item.source, ui.review_source + ' ↗', 'text-link');
    source.setAttribute('aria-label', ui.review_source + ' — ' + item.author);
    card.append(stars, make('p', 'roof-review-excerpt', item.text), credit, source);
    reviewGrid.append(card);
  }
  if (featured.length) {
    reviews.querySelector('[data-featured-intro]').hidden = false;
    reviewGrid.hidden = false;
    bindCarousel(reviewGrid, reviews.querySelector('[data-review-toolbar]'));
  }
})();
